module.exports = __webpack_public_path__ + "img/green-forest.66af657f.png";